import { Checkbox, LoadSpinner } from '@calizahq/react-components-v2'
import { WorkspaceAction } from '@sales-app/context/workspace/workspace.actions'
import { useWorkspaceContext } from '@sales-app/context/workspace/workspace.hooks'
import { HomeFilters } from '@sales-app/context/workspace/workspace.type'
import { useRecommendedHomes } from '@sales-app/hooks/useRecommendedHomes/useRecommendedHomes'
import { Form, Formik } from 'formik'
import React, { FC, useMemo } from 'react'

type Option = {
  checked: boolean
  label: string
  value: string
}

type Props = {
  currentFilters: HomeFilters
}

export const AmenitySelection: FC<Props> = ({ currentFilters }) => {
  const [, WorkspaceDispatch] = useWorkspaceContext()
  const { data, isLoading } = useRecommendedHomes()

  const { amenity } = currentFilters
  const amenities = useMemo(() => {
    return !isLoading && data?.data.filters?.amenities
      ? data?.data.filters?.amenities.map((a) => ({
          label: a.title,
          value: a.id,
          checked: amenity ? !!amenity.includes(a.id) : false,
        }))
      : []
  }, [data?.data.filters?.amenities, isLoading, amenity])

  function checkOption(option: Option) {
    const checked = !option.checked
    // If checked, it means its not in active filter array
    if (!checked) {
      WorkspaceDispatch(WorkspaceAction.updateFilters({ amenity: amenity?.filter((v) => v !== option.value) }))
    } else {
      WorkspaceDispatch(
        WorkspaceAction.updateFilters({ amenity: amenity ? [...amenity, option.value] : [option.value] }),
      )
    }
  }
  return (
    <div className={`flex h-full w-full flex-col border-b py-2 border-secondary`}>
      <p className="font-weight[500] font-bold text-tertiary">Amenity</p>

      {isLoading ? (
        <div className="flex h-48 w-full items-center justify-center ">
          <LoadSpinner className="icon-secondary" isCurrentColor={true} size={2} />
        </div>
      ) : (
        <Formik initialValues={{}} onSubmit={() => {}}>
          <Form className="grid max-h-95 w-full grid-cols-2 gap-0 overflow-y-scroll">
            {amenities.map((option, index) => {
              return (
                <Checkbox
                  className="flex flex-row-reverse justify-between last:pb-0 md:flex-row md:justify-start md:first:mt-1"
                  id={option.label}
                  key={index + option.label}
                  label={option.label}
                  name={option.value}
                  onChange={() => checkOption(option)}
                  value={option.value}
                />
              )
            })}
          </Form>
        </Formik>
      )}
    </div>
  )
}
